const footerColumns = [
  {
    title: 'Architecture',
    items: ['Clean Architecture', 'Modular Design', 'Separation of Concerns', 'Long-term Maintainability'],
  },
  {
    title: 'Performance',
    items: ['Memory Efficiency', 'Responsive Systems', 'Load Management', 'Resource Optimization'],
  },
  {
    title: 'Quality',
    items: ['Continuous Evolution', 'Process Refinement', 'Technology Adoption', 'Engineering Standards'],
  },
];

export default function ContactFooter() {
  return (
    <footer className="bg-foreground-950 mx-4 md:mx-6 mb-4 md:mb-6 rounded-2xl overflow-hidden">
      <div className="px-8 md:px-16 pt-12 md:pt-16 pb-0">
        <div className="flex items-center justify-between">
          <div className="w-6 h-6 border border-foreground-600 flex items-center justify-center">
            <div className="w-3 h-3 border border-foreground-600"></div>
          </div>
          <span className="text-xs text-foreground-500 font-label">
            Engineering excellence, built to last
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mt-12 md:mt-14 pb-12 md:pb-16">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-label text-background-50 mb-5 font-semibold tracking-wide">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.items.map((item) => (
                  <li key={item} className="text-sm text-foreground-400 font-label leading-relaxed">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="flex flex-col justify-between">
            <span className="text-lg font-heading text-background-50">
              &copy; {new Date().getFullYear()}
            </span>
            <span className="text-sm text-foreground-500 mt-2 font-label">
              All rights reserved
            </span>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/50"></div>

      <div className="px-8 md:px-16 py-10 md:py-14 flex flex-col md:flex-row gap-8 md:gap-10">
        <div className="w-full md:w-[30%] h-[180px] rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20softly%20lit%20server%20architecture%20interior%2C%20minimalist%20engineering%20workspace%2C%20no%20human%20presence%2C%20ambient%20indicator%20lights%2C%20dark%20industrial%20environment%2C%20clean%20cable%20management%2C%20modern%20data%20center%20aesthetic%2C%20subdued%20lighting%2C%20professional%20technical%20photography&width=500&height=300&seq=footer-tech-scene&orientation=landscape"
            alt="Abstract technical interior scene"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="w-full md:w-[35%] flex items-center">
          <p className="text-2xl md:text-3xl font-heading text-background-50/90 leading-[1.3]">
            Reliability and precision
            <br />
            in every solution
            <br />
            we deliver
          </p>
        </div>

        <div className="w-full md:w-[35%]">
          <p className="text-xs text-foreground-500 font-label mb-4 uppercase tracking-wider">
            Get in touch
          </p>
          <div className="space-y-1.5">
            <p className="text-sm text-foreground-400 font-label">
              Address: Punct Grui
            </p>
            <p className="text-sm text-foreground-400 font-label">
              City: Corbeni
            </p>
            <p className="text-sm text-foreground-400 font-label">
              Zip: 0
            </p>
            <p className="text-sm text-foreground-400 font-label">
              Country: Romania
            </p>
            <p className="text-sm text-foreground-400 font-label">
              Phone number: +40 778130768
            </p>
            <p className="text-sm text-foreground-400 font-label">
              Email: ceo@vabrsolutions.com
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}